<template>
  <div class="order-detail-contain">
    <el-tabs v-model="activeName">
      <el-tab-pane label="待制作" name="first">
        <invoiceWait></invoiceWait>
      </el-tab-pane>
      <el-tab-pane label="发票列表" name="second">
        <invoiceList></invoiceList>
      </el-tab-pane>
      <el-tab-pane label="回收站" name="four">
        <invoiceDelete></invoiceDelete>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { ref } from "vue";
import invoiceWait from "./Wait/index.vue";
import invoiceList from "./List/index.vue";
import invoiceDelete from "./Delete/index.vue";
export default {
  name: "invoice",
  components: {
    invoiceList,
    invoiceWait,
    invoiceDelete,
  },
  setup() {
    const activeName = ref("first");

    return {
      activeName,
    };
  },
};
</script>
<style scoped lang="scss">
.order-detail-contain {
  height: 100%;
  padding: 20px 0;
  .el-tabs {
    height: 100%;
    :deep .el-tabs__content {
      height: calc(100% - 100px);
    }
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
